import * as React from 'react';

import Icon from '@ant-design/icons/lib/components/Icon';

const IPen = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
            <svg
            width="18"
            height="21"
            viewBox="0 0 18 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.64706 20.1176C1.90729 20.1176 1.28118 19.8614 0.768706 19.3489C0.256235 18.8365 0 18.2104 0 17.4706V14.4164H3.17647V0H18V17.4706C18 18.2104 17.7438 18.8365 17.2313 19.3489C16.7188 19.8614 16.0927 20.1176 15.3529 20.1176H2.64706ZM15.3529 18.5294C15.6529 18.5294 15.9044 18.4279 16.1074 18.225C16.3103 18.0221 16.4118 17.7706 16.4118 17.4706V1.58824H4.76471V14.4164H14.2941V17.4706C14.2941 17.7706 14.3956 18.0221 14.5985 18.225C14.8015 18.4279 15.0529 18.5294 15.3529 18.5294ZM6.02709 6.5565V4.96827H15.1494V6.5565H6.02709ZM6.02709 9.61094V8.02271H15.1494V9.61094H6.02709ZM2.64706 18.5294H12.7059V16.0044H1.58824V17.4706C1.58824 17.7706 1.68971 18.0221 1.89265 18.225C2.09559 18.4279 2.34706 18.5294 2.64706 18.5294ZM2.64706 18.5294H1.58824H12.7059H2.64706Z"
              fill="#AEA9B1"
            />
          </svg>

        );
      }}
      {...props}
    />
  );
};

export default IPen;
